import React from 'react';
import SignUpForm from '../../components/form/SignUpForm';

const SignUpPage: React.FC = () => {
  return <SignUpForm />;
};

export default SignUpPage;
